import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { AuthForm } from '@/components/auth-form'
import { AccountHeader } from '@/components/account-nav'
import { getBillingStatus, postLogin } from '@/lib/kwykedit-api'

export const Route = createFileRoute('/routes/login')({
  component: LoginPage,
})

function LoginPage() {
  const navigate = useNavigate()

  const handleLogin = async (email: string, password: string) => {
    await postLogin(email, password)
    const hasAccess = await getBillingStatus()
      .then((s) => s.has_access)
      .catch(() => true)
    await navigate({ to: hasAccess ? '/projects' : '/pricing' })
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <AccountHeader />
      <div className="mx-auto max-w-md px-6 py-12">
        <h1 className="mb-2 text-2xl font-bold">Welcome back</h1>
        <p className="mb-6 text-sm text-muted-foreground">Log in to keep editing.</p>
        <div className="rounded-xl border border-border bg-card p-6">
          <AuthForm
            submitLabel="Log in"
            onSubmit={handleLogin}
            switchPrompt="No account yet?"
            switchTo="/signup"
            switchLabel="Sign up"
          />
        </div>
        <p className="mt-4 text-center text-xs text-muted-foreground">
          <Link to="/forgot" className="underline hover:opacity-80">
            Forgot your password?
          </Link>
        </p>
        <p className="mt-2 text-center text-xs text-muted-foreground">
          <Link to="/" className="underline hover:opacity-80">
            ← Back to home
          </Link>
        </p>
      </div>
    </div>
  )
}
